/**
 * Экран, отображаемый когда устройство удалено из системы
 */
import './DeviceDeletedScreen.css'

export function DeviceDeletedScreen() {
  return (
    <div className="device-deleted-screen">
      <div className="device-deleted-content">
        <div className="device-deleted-icon">🚫</div>
        <h1 className="device-deleted-title">Устройство удалено из системы</h1>
        <p className="device-deleted-message">
          Это устройство было удалено из системы администратором.
          Обратитесь к администратору для повторной регистрации.
        </p>
      </div>
    </div>
  )
}
